<template>
    <div>
        <div v-if="summaryLoading" class="text-muted small mb-3">Memuat ringkasan server…</div>
        <div v-else-if="serverSummary.length" class="mb-4">
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                <h6 class="mb-0 fw-500">Diskonek per server</h6>
                <span class="text-muted small">Tanggal: {{ displayDate }} · Total {{ serverTotal }} event</span>
            </div>
            <div class="table-responsive">
                <table class="table table-sm table-bordered mb-0">
                    <thead class="bg-light">
                        <tr>
                            <th style="width:100px">Server ID</th>
                            <th>URL node</th>
                            <th style="width:120px" class="text-right">Jumlah diskonek</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in serverSummarySorted" :key="'s-' + row.server_id">
                            <td>{{ row.server_id }}</td>
                            <td class="text-break">{{ row.server_url || '—' }}</td>
                            <td class="text-right"><strong>{{ row.total }}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else class="text-muted small mb-3">Tidak ada data diskonek untuk tanggal ini.</div>

        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
            :isLoading.sync="table.isLoading" :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            perPageDropdown: [10, 25, 50, 100],
          }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'username'">
                    {{ props.row.username }}
                </span>
                <span v-else-if="props.column.field == 'email'">
                    {{ props.row.email }}
                </span>
                <span v-else-if="props.column.field == 'phone'">
                    {{ props.row.devicename }}
                </span>
                <span v-else-if="props.column.field == 'status'">
                    <span v-if="props.row.status == 'success'" class="badge badge-success">Sukses</span>
                    <span v-if="props.row.status == 'pending'" class="badge badge-warning text-white">Pending</span>
                    <span v-if="props.row.status == 'failed'" class="badge badge-danger text-white">Gagal</span>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        props: ["date"],
        data() {
            return {
                serverSummary: [],
                summaryLoading: false,
                table: {
                    total_records: 100,
                    isLoading: true,
                    columns: [{
                            label: "Username",
                            field: "username",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "20%",
                        },
                        {
                            label: "Email",
                            field: "email",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "20%",
                        },
                        {
                            label: "Device name",
                            field: "devicename",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "20%",
                        },
                        {
                            label: "Status Notif",
                            field: "notif_status",
                            filterOptions: {
                                enabled: false,
                            },
                            sortable: false,
                            width: "20%",
                        },
                        {
                            label: "Device Pengirim",
                            field: "dev_sender_name",
                            sortable: false,
                            width: "20%",
                        },
                    ],
                    rows: [],
                    serverParams: {
                        columnFilters: {},
                        sort: [{
                            field: "",
                            type: "",
                        }, ],
                        date: moment().format("YYYY-MM-DD"),
                        page: 1,
                        limit: 10,
                    },
                },
            };
        },
        computed: {
            displayDate() {
                return moment.utc(this.date).format("YYYY-MM-DD");
            },
            serverTotal() {
                return this.serverSummary.reduce((n, r) => n + (Number(r.total) || 0), 0);
            },
            serverSummarySorted() {
                return [...this.serverSummary].sort(
                    (a, b) => (Number(a.server_id) || 0) - (Number(b.server_id) || 0)
                );
            },
        },
        watch: {
            date: {
                handler(v){
                    this.table.serverParams.date = moment.utc(v).format("YYYY-MM-DD")
                    this.loadItems()
                },
                deep: true
            }
        },
        mounted() {
            this.fn = () => {
                this.loadItems();
            }
            this.$root.$on("refresh_table", this.fn);
            this.loadItems();
        },
        beforeDestroy() {
            this.$root.$off("refresh_table", this.fn);
        },
        methods: {
            formatRupiah(numb) {
                const format = numb.toString().split('').reverse().join('');
                const convert = format.match(/\d{1,3}/g);
                const rupiah = 'Rp ' + convert.join('.').split('').reverse().join('')
                return rupiah
            },
            convertTimezone(utc) {
                return moment.unix(utc / 1000).format("YYYY-MM-DD HH:mm:ss")
            },
            updateParams(newProps) {
                this.table.serverParams = Object.assign({},
                    this.table.serverParams,
                    newProps
                );
            },
            onPageChange(params) {
                this.updateParams({
                    page: params.currentPage
                });
                this.loadItems();
            },
            onPerPageChange(params) {
                this.updateParams({
                    limit: params.currentPerPage
                });
                this.loadItems();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.table.columns[params.columnIndex].field,
                    }, ],
                });
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            async loadItems() {
                this.table.isLoading = true
                this.summaryLoading = true
                try {
                    let response = await this.getFromServer(this.table.serverParams);
                    this.table.total_records = response.data.data.total_records;
                    this.table.rows = response.data.data.devDiskonek;
                    this.serverSummary = response.data.data.server_summary || [];
                } catch (err) {
                    this.$toast.error("Too many request");
                }
                this.table.isLoading = false
                this.summaryLoading = false
            },
            async getFromServer(param) {
                return await this.$store.dispatch("device_diskonek_list", param);
            },
        },
    };
</script>

<style scoped>
    .margin5 {
        margin: 5px;
    }
</style>
